import { render, staticRenderFns } from "./documents-table.vue?vue&type=template&id=d81cd5c8"
import script from "./documents-table.vue?vue&type=script&lang=js"
export * from "./documents-table.vue?vue&type=script&lang=js"
import style0 from "./documents-table.vue?vue&type=style&index=0&id=d81cd5c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports